import { motion } from 'motion/react';
import {
  Cloud,
  Sparkles,
  AudioLines,
  Video,
  Globe,
  Smartphone,
  CheckCircle2,
  Menu,
  X
} from 'lucide-react';
import { useState } from 'react';
import { cn } from './lib/utils';
import './index0.css';
import './index.css';

export default function Myapp() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen selection:bg-primary/30">
      {/* Navigation */}
      {/*<nav className="fixed top-0 w-full z-50 flex justify-between items-center px-6 md:px-12 h-20 max-w-7xl mx-auto left-0 right-0 glass-panel border-b border-white/10">
        <div className="flex items-center gap-3">
          <Cloud className="text-primary w-6 h-6 fill-primary/20" />
          <span className="text-xl font-bold tracking-tighter text-on-surface subtle-shadow">Aether AI</span>
        </div>

        <div className="hidden md:flex items-center gap-8 font-medium tracking-tight">
          <a className="text-on-surface border-b-2 border-primary pb-1" href="#">Myapp</a>
          <a className="text-on-surface-variant hover:text-on-surface transition-colors subtle-shadow" href="#">PWA</a>
          <a className="text-on-surface-variant hover:text-on-surface transition-colors subtle-shadow" href="#">Home</a>
          <a className="text-on-surface-variant hover:text-on-surface transition-colors subtle-shadow" href="#">Contact</a>
        </div>

        <div className="flex items-center gap-4">
          <button className="hidden md:block bg-gradient-to-br from-primary to-primary-container text-on-primary px-6 py-2.5 rounded-full font-semibold hover:scale-105 transition-transform active:scale-95 shadow-lg">
            Start Building
          </button>
          <button
            className="md:hidden text-on-surface"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X /> : <Menu />}
          </button>
        </div> */}

        {/* Mobile Menu */}
        {/*{isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="absolute top-20 left-0 w-full glass-card p-6 flex flex-col gap-4 md:hidden"
          >
            <a className="text-on-surface font-medium" href="#">Myapp</a>
            <a className="text-on-surface-variant" href="#">PWA</a>
            <a className="text-on-surface-variant" href="#">Home</a>
            <a className="text-on-surface-variant" href="#">Contact</a>
            <button className="bg-gradient-to-br from-primary to-primary-container text-on-primary px-6 py-3 rounded-full font-semibold">
              Start Building
            </button>
          </motion.div>
        )}
      </nav> 
      */}

      <main className="relative pt-32 px-6 max-w-7xl mx-auto overflow-hidden">
        {/* Hero Section */}
        <section className="grid lg:grid-cols-2 gap-12 items-center mb-40">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex flex-col gap-6"
          >
            <div className="inline-flex items-center self-start px-3 py-1 rounded-full glass-card text-primary font-medium text-xs uppercase tracking-widest">
              <Sparkles className="w-4 h-4 mr-2 fill-primary/20" />
              Powered by Google Gemini
            </div>
            <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-on-surface leading-[1.1] subtle-shadow">
              Launch Your Own <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-300 via-primary to-secondary">AI English Teacher</span>
            </h1>
            <p className="text-xl text-on-surface-variant leading-relaxed max-w-xl subtle-shadow">
              Give your institute a powerful AI English Teacher — fully branded with your own domain. Speak. See. Interact. Creating a true learning experience, not just another app.
            </p>
            <div className="flex flex-wrap gap-4 pt-4">
              <button onClick={() => window.location.href = "./contact"} className="bg-gradient-to-br from-primary to-primary-container text-on-primary px-8 py-4 rounded-full font-bold text-lg shadow-2xl hover:shadow-primary/40 transition-all">
                Get Started - €160
              </button>
              <button onClick={() => window.location.href = "./teacher"} className="glass-card text-on-surface px-8 py-4 rounded-full font-bold text-lg hover:bg-white/10 transition-all border-white/20">
                View Demo
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="absolute -inset-20 bg-primary/10 blur-[120px] rounded-full"></div>
            <div className="glass-card rounded-3xl overflow-hidden aspect-[4/3] shadow-2xl relative z-10 border-white/10">
              <img
                className="w-full h-full object-cover opacity-60 mix-blend-screen"
                src="https://images.unsplash.com/photo-1633356122544-f134324a6cee?auto=format&fit=crop&q=80&w=1200"
                alt="AI Interface"
                referrerPolicy="no-referrer"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-40"></div>
              <div className="absolute bottom-6 left-6 flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-tertiary/20 flex items-center justify-center border border-tertiary/40 backdrop-blur-md">
                  <AudioLines className="text-tertiary w-6 h-6" />
                </div>
                <div>
                  <p className="text-sm font-bold text-on-surface subtle-shadow">Live Interaction</p>
                  <p className="text-xs text-on-surface-variant">Bidirectional Voice & Vision</p>
                </div>
              </div>
            </div>
          </motion.div>
        </section>

        {/* Bento Grid Features */}
        <section className="mb-40">
          <div className="grid md:grid-cols-12 gap-6">
            {/* Large Feature */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="md:col-span-8 glass-card p-10 rounded-[2.5rem] flex flex-col justify-between group"
            >
              <div>
                <Video className="text-primary w-10 h-10 mb-6" />
                <h3 className="text-3xl font-bold mb-4 text-on-surface subtle-shadow">Real-Time Conversations That Feel Natural</h3>
                <p className="text-on-surface-variant text-lg max-w-md leading-relaxed subtle-shadow">
                  Powered by live, bidirectional communication, your AI teacher delivers smooth, human-like interaction — just like a real conversation.
                </p>
              </div>
              <div className="mt-12 flex flex-wrap gap-4">
                {['Low Latency', 'Voice Processing', 'Visual Context'].map((tag) => (
                  <div key={tag} className="bg-white/5 px-4 py-2 rounded-xl text-sm border border-white/10 backdrop-blur-md text-on-surface">
                    {tag}
                  </div>
                ))}
              </div>
            </motion.div>

            {/* Small Feature 1 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="md:col-span-4 glass-card p-8 rounded-[2.5rem] flex flex-col items-center text-center"
            >
              <div className="w-16 h-16 bg-primary/20 rounded-2xl flex items-center justify-center mb-6 border border-primary/30">
                <Globe className="text-primary w-8 h-8" />
              </div>
              <h4 className="text-xl font-bold mb-2 text-on-surface subtle-shadow">Your Own Domain</h4>
              <p className="text-on-surface-variant subtle-shadow">Fully branded (yourname.com) with no generic platform links.</p>
            </motion.div>

            {/* Small Feature 2 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="md:col-span-4 glass-card p-8 rounded-[2.5rem] flex flex-col items-center text-center"
            >
              <div className="w-16 h-16 bg-tertiary/10 rounded-2xl flex items-center justify-center mb-6 border border-tertiary/20">
                <Smartphone className="text-tertiary w-8 h-8" />
              </div>
              <h4 className="text-xl font-bold mb-2 text-on-surface subtle-shadow">PWA Experience</h4>
              <p className="text-on-surface-variant subtle-shadow">Installable on any device. No app store. No friction.</p>
            </motion.div>

            {/* Medium Feature */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="md:col-span-8 glass-card p-10 rounded-[2.5rem] relative overflow-hidden group"
            >
              <div className="relative z-10 flex flex-col h-full justify-center">
                <h3 className="text-3xl font-bold mb-4 text-on-surface subtle-shadow">Powered by Gemini Multimodal</h3>
                <p className="text-on-surface-variant text-lg max-w-lg subtle-shadow">
                  The Live API enables low-latency voice and vision interactions. It processes continuous streams of audio, images, and text to deliver immediate responses.
                </p>
              </div>
              <div className="absolute right-0 top-0 w-1/3 h-full opacity-20 group-hover:opacity-30 transition-opacity">
                <img
                  className="w-full h-full object-cover mix-blend-overlay"
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Colored_neural_network.svg/330px-Colored_neural_network.svg.png"
                  alt="Neural Network"
                  referrerPolicy="no-referrer"
                />
              </div>
            </motion.div>
          </div>
        </section>

        {/* CTA & Pricing */}
        <section className="mb-40 text-center py-20 relative">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full bg-primary/10 blur-[150px] rounded-full"></div>
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="relative z-10 max-w-3xl mx-auto glass-card p-12 rounded-[3rem] border-white/20 bg-white/5"
          >
            <h2 className="text-4xl font-bold mb-4 text-on-surface subtle-shadow">One-Time Payment. <br />Lifetime Access.</h2>
            <div className="flex items-center justify-center gap-2 mb-8">
              <span className="text-6xl font-black text-primary drop-shadow-[0_0_20px_rgba(179,197,255,0.4)]">€160</span>
              <div className="text-left">
                <p className="text-on-surface-variant/50 line-through text-sm">€499</p>
                <p className="text-tertiary font-bold subtle-shadow">Limited Offer</p>
              </div>
            </div>
            <div className="grid md:grid-cols-2 gap-4 text-left mb-10">
              {[
                'No monthly subscriptions',
                'Full source code ownership',
                'Unlimited student capacity',
                'Free software updates'
              ].map((feature) => (
                <div key={feature} className="flex items-center gap-3">
                  <CheckCircle2 className="text-tertiary w-5 h-5" />
                  <span className="text-on-surface subtle-shadow">{feature}</span>
                </div>
              ))}
            </div>
            <button onClick={() => window.location.href = "./contact"} className="w-full py-5 rounded-2xl bg-gradient-to-r from-primary to-primary-container text-on-primary font-black text-xl hover:scale-[1.02] transition-transform shadow-xl">
              SECURE LIFETIME ACCESS
            </button>
            <p className="mt-4 text-on-surface-variant text-sm subtle-shadow">No hidden fees. Yours forever.</p>
          </motion.div>
        </section>
      </main>

      {/* Footer */}
      {/*<footer className="w-full py-12 px-8 flex flex-col md:flex-row justify-between items-center border-t border-white/10 bg-white/5 backdrop-blur-2xl mt-24">
        <div className="flex flex-col gap-2 mb-8 md:mb-0">
          <div className="flex items-center gap-2 font-black text-primary">
            <Cloud className="w-6 h-6 fill-primary/20" />
            <span className="subtle-shadow">Aether AI</span>
          </div>
          <p className="text-sm tracking-wide text-on-surface-variant/50 subtle-shadow">© 2024 Aether AI. The Celestial Canvas.</p>
        </div>
        <div className="flex gap-10">
          {['Myapp', 'PWA', 'Home', 'Contact'].map((link) => (
            <a
              key={link}
              className="text-on-surface-variant transition-all duration-200 hover:text-on-surface underline-offset-4 hover:underline text-sm tracking-wide subtle-shadow"
              href="#"
            >
              {link}
            </a>
          ))}
        </div>
      </footer> */}
    </div>
    
  );
}
